export default class SelectionQuizAAnswer {
  constructor(public readonly choiceId: string) {}
}
